import { MobileOpCode, QueryGetAccessEventsForTenantArgs } from 'graphql/generated/graphqlTypes';
import * as v1graphqlQueries from 'graphql/queries';
import * as graphqlQueries from 'graphql/v2/queries';
import { mockedGetAccessCardsDataForQuery } from 'mocks/graphqlApollo/query/getAccessCards';
import {
  mockedGetAccessEventsForTenantDataForQueryFirstFetch,
  mockedGetAccessEventsForTenantDataForQuerySecondFetch,
  mockedGetAccessEventsForTenantDataForQueryWithFiltersFirstFetch,
  mockedGetAccessEventsForTenantDataForTimeWindow
} from 'mocks/graphqlApollo/query/getAccessEventsForTenant';
import { mockedGetAllVisitorsForTenantData } from 'mocks/graphqlApollo/query/getAllVisitorsForTenant';
import { mockedGetCardsDataForQuery } from 'mocks/graphqlApollo/query/getCards';
import { mockedGetCurrentTenantDataForQuery } from 'mocks/graphqlApollo/query/getCurrentTenant';
import {
  cleanGetAccessCardsData,
  cleanGetAllVisitorsForTenantData,
  cleanGetAllVisitorsGroupsWithoutNestedResolversData,
  cleanGetDoorsForTenantData,
  cleanGetLocationsForTenantData,
  cleanGetVisitorGroupsForTenantData,
  emptyGetAccessCardsData,
  emptyGetAllVisitorsForTenantData,
  emptyGetDoorsForTenantData,
  emptyGetLocationsForTenantData,
  emptyGetVisitorGroupsForTenantData
} from 'mocks/graphqlApollo/query/getDashboardCleanState';
import { mockedGetQrCodeVisitsForTenantData } from 'mocks/graphqlApollo/query/getQrCodeVisitsForTenant';
import { mockedGetRestAPIKeysDataForQuery } from 'mocks/graphqlApollo/query/getRestAPIKeys';
import { mockCloudControllers } from 'mocks/graphqlMocks/cloudControllerFixtures';
import { pickDashboardDemoData } from 'mocks/graphqlMocks/dashboardDemoState';
import { mockDoors } from 'mocks/graphqlMocks/doorFixtures';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';
import { mockedGetAllVisitorsCardsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getAllVisitorsCardsWithoutNestedResolvers';
import { mockedGetAllVisitorsGroupsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getAllVisitorsGroupsWithoutNestedResolvers';
import { mockedGetAllVisitorsVisitorGroupsDataForQuery } from '../graphqlApollo/query/getAllVisitorsVisitorGroups';
import { mockedGetAllVisitorsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getAllVisitorsWithoutNestedResolvers';
import { mockedGetCurrentVisitorAdminDataForQuery } from '../graphqlApollo/query/getCurrentVisitor';
import { mockedGetDoorsForAccessEventsFiltersDataForQuery } from '../graphqlApollo/query/getDoorsForAccessEventsFilters';
import {
  mockedGetDoorsForTenantDataAdmin,
  mockedGetDoorsForTenantDataForQuery
} from '../graphqlApollo/query/getDoorsForTenant';
import { mockedGetDoorsForTenantWithLocationsDataAdmin } from '../graphqlApollo/query/getDoorsForTenantWithLocations';
import { mockedGetDoorsWithOfficeDaysForTenantDataAdmin } from '../graphqlApollo/query/getDoorsForTenantWithOfficeMode';
import { mockedGetDoorsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getDoorsWithoutNestedResolvers';
import { mockedGetLocationsWithoutNestedResolversDataAdmin } from '../graphqlApollo/query/getLocationsWithoutNestedResolvers';
import {
  mockedGetVisitorDetailsData,
  mockedGetVisitorDetailsDataForQueryVisitor1,
  mockedGetVisitorDetailsDataForQueryVisitor10,
  mockedGetVisitorDetailsDataForQueryVisitor11,
  mockedGetVisitorDetailsDataForQueryVisitor12,
  mockedGetVisitorDetailsDataForQueryVisitor13,
  mockedGetVisitorDetailsDataForQueryVisitor14,
  mockedGetVisitorDetailsDataForQueryVisitor15,
  mockedGetVisitorDetailsDataForQueryVisitor16,
  mockedGetVisitorDetailsDataForQueryVisitor17,
  mockedGetVisitorDetailsDataForQueryVisitor18,
  mockedGetVisitorDetailsDataForQueryVisitor19,
  mockedGetVisitorDetailsDataForQueryVisitor2,
  mockedGetVisitorDetailsDataForQueryVisitor20,
  mockedGetVisitorDetailsDataForQueryVisitor3,
  mockedGetVisitorDetailsDataForQueryVisitor4,
  mockedGetVisitorDetailsDataForQueryVisitor5,
  mockedGetVisitorDetailsDataForQueryVisitor6,
  mockedGetVisitorDetailsDataForQueryVisitor7,
  mockedGetVisitorDetailsDataForQueryVisitor8,
  mockedGetVisitorDetailsDataForQueryVisitor9,
  mockedGetVisitorDetailsDataForQueryVisitorInstaller2
} from '../graphqlApollo/query/getVisitorDetails';
import { mockedGetVisitorGroupsForTenantWithAccessGrantsDataAdmin } from '../graphqlApollo/query/getVisitorGroupsForTenantWithAccessGrants';
import { mockedGetVisitorGroupsForTenantWithIsAdminGroupDataAdmin } from '../graphqlApollo/query/getVisitorGroupsForTenantWithIsAdminGroupDataForQuery';
import { mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledDataAdmin } from '../graphqlApollo/query/getVisitorGroupsForTenantWithIsOfficeModeEnabled';
import { mockedGetVisitorGroupsForTenantWithMembersAndRoleDataAdmin } from '../graphqlApollo/query/getVisitorGroupsForTenantWithMembersAndRole';
import {
  mockedGetVisitorGroupsForTenantWithMembersAndTypesDataAdmin,
  mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery
} from '../graphqlApollo/query/getVisitorGroupsForTenantWithMembersAndTypes';
import { mockedGetVisitorGroupsWithSchedulesForTenantDataAdmin } from '../graphqlApollo/query/getVisitorGroupsForTenantWithSchedules';
import { mockedGetVisitorGroupsForTenantWithTypesDataAdmin } from '../graphqlApollo/query/getVisitorGroupsForTenantWithTypes';
import { mockedGetVisitorGroupsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getVisitorGroupsWithoutNestedResolvers';
import { mockedGetVisitorsAccessEventsFiltersDataForQuery } from '../graphqlApollo/query/getVisitorsAccessEventsFilters';
import { mockedGetVisitorsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getVisitorsWithoutNestedResolvers';

const visitorDetailsQueries = [
  { id: 'mockVisitorId1', data: mockedGetVisitorDetailsDataForQueryVisitor1 },
  { id: 'mockVisitorId2', data: mockedGetVisitorDetailsDataForQueryVisitor2 },
  { id: 'mockVisitorId3', data: mockedGetVisitorDetailsDataForQueryVisitor3 },
  { id: 'mockVisitorId4', data: mockedGetVisitorDetailsDataForQueryVisitor4 },
  { id: 'mockVisitorId5', data: mockedGetVisitorDetailsDataForQueryVisitor5 },
  { id: 'mockVisitorId6', data: mockedGetVisitorDetailsDataForQueryVisitor6 },
  { id: 'mockVisitorId7', data: mockedGetVisitorDetailsDataForQueryVisitor7 },
  { id: 'mockVisitorId8', data: mockedGetVisitorDetailsDataForQueryVisitor8 },
  { id: 'mockVisitorId9', data: mockedGetVisitorDetailsDataForQueryVisitor9 },
  { id: 'mockVisitorId10', data: mockedGetVisitorDetailsDataForQueryVisitor10 },
  { id: 'mockVisitorId11', data: mockedGetVisitorDetailsDataForQueryVisitor11 },
  { id: 'mockVisitorId12', data: mockedGetVisitorDetailsDataForQueryVisitor12 },
  { id: 'mockVisitorId13', data: mockedGetVisitorDetailsDataForQueryVisitor13 },
  { id: 'mockVisitorId14', data: mockedGetVisitorDetailsDataForQueryVisitor14 },
  { id: 'mockVisitorId15', data: mockedGetVisitorDetailsDataForQueryVisitor15 },
  { id: 'mockVisitorId16', data: mockedGetVisitorDetailsDataForQueryVisitor16 },
  { id: 'mockVisitorId17', data: mockedGetVisitorDetailsDataForQueryVisitor17 },
  { id: 'mockVisitorId18', data: mockedGetVisitorDetailsDataForQueryVisitor18 },
  { id: 'mockVisitorId19', data: mockedGetVisitorDetailsDataForQueryVisitor19 },
  { id: 'mockVisitorId20', data: mockedGetVisitorDetailsDataForQueryVisitor20 },
  { id: 'mockVisitorInstaller2', data: mockedGetVisitorDetailsDataForQueryVisitorInstaller2 },
  {
    id: 'mockedAutomatedTestsUIAdminVisitorId',
    data: mockedGetVisitorDetailsData(mockedGetCurrentVisitorAdminDataForQuery.getCurrentVisitor)
  }
];

const visitorAccessEventsIds = visitorDetailsQueries.map(({ id }) => id);

const doorAccessEventsIds = mockDoors.map(({ id }) => id);

export const queries = [
  {
    request: {
      query: v1graphqlQueries.GET_CURRENT_HOST
    },
    result: { data: mockedGetCurrentVisitorAdminDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: v1graphqlQueries.GET_CURRENT_VISITOR
    },
    result: { data: mockedGetCurrentVisitorAdminDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: v1graphqlQueries.GET_CURRENT_TENANT
    },
    result: { data: mockedGetCurrentTenantDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: v1graphqlQueries.GET_DOORS_FOR_TENANT_WITH_OFFICE_MODE
    },
    result: { data: mockedGetDoorsWithOfficeDaysForTenantDataAdmin },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS_AND_ROLE,
      variables: {
        filter: {
          type: VisitorGroupType.CoContractors
        }
      }
    },
    result: { data: mockedGetVisitorGroupsForTenantWithMembersAndRoleDataAdmin },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: v1graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS,
      variables: {
        filter: {
          type: VisitorGroupType.Installers
        }
      }
    },
    result: { data: mockedGetVisitorGroupsForTenantWithMembersAndTypesDataAdmin },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: v1graphqlQueries.GET_VISITOR_GROUPS_WITH_PERMISSIONS,
      variables: {
        filter: {
          type: VisitorGroupType.AzureAd
        }
      }
    },
    result: { data: mockedGetVisitorGroupsForTenantWithIsAdminGroupDataAdmin },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT_WITH_SCHEDULES
    },
    result: { data: mockedGetVisitorGroupsWithSchedulesForTenantDataAdmin },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: v1graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT
    },
    result: { data: mockedGetVisitorGroupsForTenantWithTypesDataAdmin },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: v1graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT_WITH_IS_OFFICE_MODE_ENABLED
    },
    result: { data: mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledDataAdmin },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: v1graphqlQueries.GET_DOORS_FOR_TENANT_WITH_LOCATIONS
    },
    result: { data: mockedGetDoorsForTenantWithLocationsDataAdmin },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: v1graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT_WITH_ACCESS_GRANTS
    },
    result: { data: mockedGetVisitorGroupsForTenantWithAccessGrantsDataAdmin },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_REST_API_KEYS
    },
    result: { data: mockedGetRestAPIKeysDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: v1graphqlQueries.GET_CARDS
    },
    result: { data: mockedGetCardsDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: v1graphqlQueries.GET_ALL_VISITORS_CARDS
    },
    result: { data: mockedGetCardsDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ACCESS_CARDS
    },
    result: () => ({
      data: pickDashboardDemoData(emptyGetAccessCardsData, cleanGetAccessCardsData, mockedGetAccessCardsDataForQuery)
    }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ACCESS_EVENTS_FOR_TENANT,
      variables: { filter: { actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted] } }
    },
    result: { data: mockedGetAccessEventsForTenantDataForQueryFirstFetch },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ACCESS_EVENTS_FOR_TENANT,
      variables: {
        nextToken: 'mockedNextToken',
        filter: { actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted] }
      }
    },
    result: { data: mockedGetAccessEventsForTenantDataForQuerySecondFetch },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ACCESS_EVENTS_FOR_TENANT,
      variables: (variables: QueryGetAccessEventsForTenantArgs) => Boolean(variables?.filter?.dateRange)
    },
    // every dashboard chart queries this window, so the mock has to stay usable for all of them
    maxUsageCount: Number.POSITIVE_INFINITY,
    result: (variables: QueryGetAccessEventsForTenantArgs) => ({
      data: mockedGetAccessEventsForTenantDataForTimeWindow(variables?.filter)
    })
  },
  ...visitorAccessEventsIds.map((visitorId) => ({
    request: {
      query: graphqlQueries.GET_ACCESS_EVENTS_FOR_TENANT,
      variables: {
        filter: { visitorIds: [visitorId], actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted] }
      }
    },
    result: { data: mockedGetAccessEventsForTenantDataForQueryWithFiltersFirstFetch },
    maxUsageCount: Number.POSITIVE_INFINITY
  })),
  ...doorAccessEventsIds.map((doorId) => ({
    request: {
      query: graphqlQueries.GET_ACCESS_EVENTS_FOR_TENANT,
      variables: {
        filter: { doorIds: [doorId], actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted] }
      }
    },
    result: { data: mockedGetAccessEventsForTenantDataForQueryWithFiltersFirstFetch },
    maxUsageCount: Number.POSITIVE_INFINITY
  })),
  {
    request: {
      query: v1graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS
    },
    result: { data: mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_GROUPS
    },
    result: () => ({
      data: pickDashboardDemoData(
        emptyGetVisitorGroupsForTenantData,
        cleanGetVisitorGroupsForTenantData,
        mockedGetVisitorGroupsForTenantWithAccessGrantsDataAdmin
      )
    }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_DOORS_FOR_DEVICE_GROUPS
    },
    result: { data: mockedGetDoorsForTenantDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_FOR_TENANT
    },
    result: () => ({
      data: pickDashboardDemoData(
        emptyGetAllVisitorsForTenantData,
        cleanGetAllVisitorsForTenantData,
        mockedGetAllVisitorsForTenantData
      )
    }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_VISITOR_GROUPS
    },
    result: { data: mockedGetAllVisitorsVisitorGroupsDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_VISITOR_GROUPS,
      variables: {
        filter: {
          type: VisitorGroupType.CoContractors
        }
      }
    },
    result: { data: mockedGetAllVisitorsVisitorGroupsDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_VISITOR_GROUPS,
      variables: {
        filter: {
          type: VisitorGroupType.Administrators
        }
      }
    },
    result: { data: mockedGetAllVisitorsVisitorGroupsDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_VISITOR_GROUPS,
      variables: {
        filter: {
          type: VisitorGroupType.Installers
        }
      }
    },
    result: { data: mockedGetAllVisitorsVisitorGroupsDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_DOORS_FOR_TENANT
    },
    result: () => ({
      data: pickDashboardDemoData(
        emptyGetDoorsForTenantData,
        cleanGetDoorsForTenantData,
        mockedGetDoorsForTenantDataAdmin
      )
    }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  ...visitorDetailsQueries.map(({ id, data }) => ({
    request: {
      query: graphqlQueries.GET_VISITOR_DETAILS,
      variables: { id }
    },
    result: { data },
    maxUsageCount: Number.POSITIVE_INFINITY
  })),
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_CARDS_WITHOUT_NESTED_RESOLVERS
    },
    result: () => ({
      data: pickDashboardDemoData(
        emptyGetAccessCardsData,
        cleanGetAccessCardsData,
        mockedGetAllVisitorsCardsWithoutNestedResolversDataForQuery
      )
    }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_GROUPS_WITHOUT_NESTED_RESOLVERS,
      variables: { filter: undefined }
    },
    result: () => ({
      data: pickDashboardDemoData(
        emptyGetVisitorGroupsForTenantData,
        cleanGetAllVisitorsGroupsWithoutNestedResolversData,
        mockedGetAllVisitorsGroupsWithoutNestedResolversDataForQuery
      )
    }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_WITHOUT_NESTED_RESOLVERS
    },
    result: () => ({
      data: pickDashboardDemoData(
        emptyGetAllVisitorsForTenantData,
        cleanGetAllVisitorsForTenantData,
        mockedGetAllVisitorsWithoutNestedResolversDataForQuery
      )
    }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_VISITORS_WITHOUT_NESTED_RESOLVERS
    },
    result: { data: mockedGetVisitorsWithoutNestedResolversDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_VISITOR_GROUPS_WITHOUT_NESTED_RESOLVERS
    },
    result: { data: mockedGetVisitorGroupsWithoutNestedResolversDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_LOCATIONS_WITHOUT_NESTED_RESOLVERS
    },
    result: () => ({
      data: pickDashboardDemoData(
        emptyGetLocationsForTenantData,
        cleanGetLocationsForTenantData,
        mockedGetLocationsWithoutNestedResolversDataAdmin
      )
    }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_DOORS_WITHOUT_NESTED_RESOLVERS
    },
    result: { data: mockedGetDoorsWithoutNestedResolversDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_DOORS_FOR_ACCESS_EVENTS_FILTERS
    },
    result: { data: mockedGetDoorsForAccessEventsFiltersDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_VISITORS_ACCESS_EVENTS_FILTERS
    },
    result: () => ({ data: { getVisitors: mockedGetVisitorsAccessEventsFiltersDataForQuery.getVisitors } }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_QR_CODE_VISITS_FOR_TENANT
    },
    result: { data: mockedGetQrCodeVisitsForTenantData },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: graphqlQueries.GET_CLOUD_CONTROLLERS
    },
    result: {
      data: { cloudController: { __typename: 'CloudControllerQueries', getCloudControllers: mockCloudControllers } }
    },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  ...mockCloudControllers.map((cloudController) => ({
    request: {
      query: graphqlQueries.GET_CLOUD_CONTROLLER,
      variables: { cloudControllerId: cloudController.id }
    },
    result: {
      data: { cloudController: { __typename: 'CloudControllerQueries', getCloudController: cloudController } }
    },
    maxUsageCount: Number.POSITIVE_INFINITY
  }))
];
